import axios from "axios";

const API_URL = process.env.VUE_APP_API;
const API2_URL = process.env.VUE_APP_API2;
let API_HEADERS = null;

export default {
	setHeaders() {
		API_HEADERS = {
			headers: {
				Authorization: `Bearer ${localStorage.getItem("authorization__user-token") || null}`,
				"X-Requested-By": "web",
			},
		};
	},

	/* AUTH API */
	doExtendRegister(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.post(`${API_URL}/auth/local/register`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},

	/* SYSTEMS API */
	getProSystems(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.get(
				`${API_URL}/systems/?filters[type][$eq]=pro&filters[isDemo][$eq]=false&pagination[limit]=-1&sort=id:desc`,
				API_HEADERS
			)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	getDealers(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.get(`${API_URL}/dealers`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	getRegions(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.get(`${API_URL}/geo-regions`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},

	/* SYSTEMS API */
	getSystems(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.get(
				`${API2_URL}/getSystems/?pagination[start]=${payload.start}&pagination[limit]=${payload.limit}&filter[type]=${payload.filterType}&filter[state]=${payload.filterState}&filter[category]=${payload.filterCategory}&payload=${payload.query}`,
				API_HEADERS
			)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	createSystem(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.post(`${API2_URL}/createSystem`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	editSystem(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.put(`${API2_URL}/updateSystem/${payload.id}`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},

	/* SYSTEM API */
	getSystem(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.get(`${API_URL}/getSystem/${payload.id}`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	updateSystem(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.put(`${API_URL}/updateSystem/${payload.id}`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	updateBoard(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.put(`${API_URL}/boards/${payload.id}`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	getSystemTasks(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.get(
				`${API_URL}/tasks?filters[executor][id][$eq]=2&pagination[start]=${payload.start}&pagination[limit]=${payload.limit}`,
				API_HEADERS
			)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	getLogsMQTT(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.get(`${API_URL}/logs/${payload.id}/mqtt/`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	updateControl(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.put(`${API_URL}/systems/${payload.id}/manualControl`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	updateMode(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.put(`${API_URL}/modes/${payload.id}/${payload.action}`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	resetSystemErrors(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.put(`${API_URL}/resetErrors/${payload.id}`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},

	addEntrance(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.post(`${API_URL}/systems-pro/entrances`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	deleteEntrance(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.delete(`${API_URL}/systems-pro/entrances/${payload.id}`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},

	getZones(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.get(
				`${API_URL}/zones/?populate=devs,nozzles,hum,temp&filters[from_system][id][$eq]=${payload.id}`,
				API_HEADERS
			)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	addZone(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.post(`${API_URL}/zones`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	deleteZone(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.delete(`${API_URL}/zones/${payload.id}`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	resetZoneErrors(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.put(`${API_URL}/zones/${payload.id}/resetErrors`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},

	uploadFile(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.post(`${API_URL}/upload`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	unloadFile(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.delete(`${API_URL}/upload/files/${payload.file}`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},

	addDocument(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.post(`${API_URL}/documents`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	deleteDocument(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.delete(`${API_URL}/documents/${payload.id}`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},

	/* OBJECTS API */
	getObjects(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.get(`${API_URL}/getObjects/${payload.id}`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	updateModeVacation(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.put(`${API_URL}/modes/${payload.id}`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},

	/* PROFILE API */
	getUserMe(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.get(`${API_URL}/users/me`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	updateProfile(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.put(`${API_URL}/users/me`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	addSharedUser(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.post(`${API_URL}/mobile/users/sharedAccess/users`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	changeSharedUsers(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.all(
				payload.endpoints.map((endpoint) =>
					axios.put(`${API_URL}/mobile/users/sharedAccess/users/${endpoint.id}`, endpoint.data, API_HEADERS)
				)
			)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	addContact(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.post(`${API_URL}/contacts`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	changeContact(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.put(`${API_URL}/contacts/${payload.id}`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	changeContacts(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.all(
				payload.endpoints.map((endpoint) =>
					axios.put(`${API_URL}/contacts/${endpoint.id}`, endpoint.data, API_HEADERS)
				)
			)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	deleteContact(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.delete(`${API_URL}/contacts/${payload.id}`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	addCard(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.post(`${API_URL}/cards`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	deleteCard(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.delete(`${API_URL}/cards/${payload.id}`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	addAvatar(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.put(`${API_URL}/users/me`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	deleteAvatar(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.delete(`${API_URL}/upload/files/${payload.id}`, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	changePassword(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.post(`${API_URL}/users/changePassword`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},

	/* MESSENGER API */
	getChats(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.get(
				`${API_URL}/chat-rooms/?filters[participants][from_user]=${payload.id}&populate[0]=participants,messages&populate[1]=participants.from_user,messages.statuses`,
				API_HEADERS
			)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
	sendMessage(payload) {
		if (!API_HEADERS) this.setHeaders();

		axios
			.post(`${API_URL}/chat-messages`, payload.data, API_HEADERS)
			.then((response) => payload.success(response))
			.catch((error) => payload.error(error));
	},
};
